export default {
	langs: {
		english: 'English',
		french: 'French'
	},
	login: {
		username: 'E-mail',
		password: 'Password',
		remember: 'Remember me',
		login: 'Log in',
		logout: 'Log out',
		errUsrInvalid: 'Invalid email',
		errUsrMissing: 'Fill in your email',
		errPwdMissing: 'Fill in your password',
		errFormInvalid: 'Invalid form',
		errCSRF: 'An error occured. Please refresh the page'
	},
	network: {
		loading: 'Loading',
		sending: 'Sending'
	}
}



// WEBPACK FOOTER //
// ./src/locales/en.js